import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { mockData } from '../utils/mock';

const HeroSection = ({ onCtaClick }) => {
  return (
    <section className="hero-section">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="hero-logo">
          <img 
            src="https://customer-assets.emergentagent.com/job_keeper-elite/artifacts/0qosaxkh_971B3874-1CF5-4E9F-8857-70C3B9D443B1.png" 
            alt="The Keeper Lab"
            className="hero-logo-image"
          />
        </div>
        <p className="hero-subtitle">{mockData.hero.subtitle}</p>
        <p className="hero-description">{mockData.hero.description}</p>
        
        <div className="hero-taglines">
          <p>{mockData.hero.tagline1}</p>
          <p>{mockData.hero.tagline2}</p>
          <p className="hero-emphasis">{mockData.hero.tagline3}</p>
          <p className="hero-emphasis">{mockData.hero.tagline4}</p>
        </div>

        <Button 
          onClick={onCtaClick}
          className="hero-cta"
          size="lg"
        >
          {mockData.hero.ctaText}
          <ArrowRight className="ml-2" />
        </Button>
      </div>
    </section>
  );
};

export default HeroSection;
